export const loan_repayments_fields = [
    {
        key: 'id',
        label: '#',
        sortable: true
    },
    {
        key: 'loan_reference_no',
        sortable: true,
    },
    {
        key: 'customer_name',
        sortable: true,
    },
    {
        key: 'phone',
        sortable: true,
    },
    {
        key: 'amount_paid',
        sortable: true
    },
    {
        key: 'date_created',
        sortable: true,
    }
];

